import { render, staticRenderFns } from "./UserMerchant.vue?vue&type=template&id=704a2679&"
import script from "./UserMerchant.vue?vue&type=script&lang=js&"
export * from "./UserMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports